<template>
  <section class="content-section container px-3">
    <b-row v-if="infos.length > 0">
      <TradeShowList v-for="(data, i) in infos" :key="i" :data="data" />
    </b-row>
    <b-row v-else>
      <!-- <b-col class="text-center no-tradeshow"
        ><p>{{ noTradeShow }}</p></b-col
      > -->
    </b-row>
  </section>
</template>

<script>
import TradeShowList from "./_tradeshowlist";

export default {
  components: { TradeShowList },
  data() {
    return {
      noTradeShow:
        "There’s no trade show taking place recently due to the COVID-19 situation. Thank you for your support and please stay safe and healthy.We hope that we’ll see you soon.",
      infos: [
        {
          exhibition: "AAPEX 2025",
          date: "NOVEMBER 4–6, 2025",
          location: "Las Vegas, NV The Venetian Expo",
          boothNo: "A684",
          more: "https://www.aapexshow.com/",
          src: require("@/assets/images/tradeshow/ts_2025_aapex.jpg"),
        },
        {
          exhibition: "Automechanika Shanghai 2025",
          date: "NOVEMBER 26–29, 2025",
          location: "National Exhibition and Convention Center (Shanghai)",
          boothNo: "2.1AB16",
          more: "https://automechanika-shanghai.hk.messefrankfurt.com/shanghai/en.html",
          src: require("@/assets/images/tradeshow/ts_2025_as.jpg"),
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.no-tradeshow {
  padding: 5rem;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $color-main-aux;

  p {
    font-size: 20px;
    line-height: 2;
    color: #fff;
  }
}
</style>